"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columnFilter = void 0;
const columnFilter = (column, searchText) => [column.friendlyName, column.columnId].some((candidate) => candidate === null || candidate === void 0 ? void 0 : candidate.toLowerCase().includes(searchText.toLowerCase()));
exports.columnFilter = columnFilter;
